function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import appApis from '@/services/profile';
import utils from '@/js/utils';
export var crudDP = {
  data: function data() {
    return {
      isBusy: false,
      busy: false,
      busy2: false,
      isBusyDetail: false,
      processing: false,
      mode: '',
      record: Object,
      record_original: Object,
      overlay_message: '',
      recordSelected: null,
      items: [],
      dismissCountDown: 0,
      dismissSecs: 5,
      dangerMessage: '',
      perPage: 5,
      currentPage: 1
    };
  },
  computed: {
    readonly: function readonly() {
      return this.mode === 'view';
    },
    showMonitoringInput: function showMonitoringInput() {
      return this.mode !== 'create';
    },
    modalTitle: function modalTitle() {
      var mode = this.mode.charAt(0).toUpperCase() + this.mode.slice(1);
      var modalName = this.modalName.toUpperCase();
      return "".concat(mode, " ").concat(modalName);
    },
    areaName: function areaName() {
      var _this = this;
      return function (record_id) {
        var record = _this.select_profile_areas.filter(function (rec) {
          return rec.record_id === record_id;
        });
        var recordName = '';
        if (record.length) {
          recordName = record[0].area_description;
        }
        return recordName;
      };
    },
    userProfileName: function userProfileName() {
      var _this2 = this;
      return function (record_id) {
        var record = _this2.select_profile_users.filter(function (rec) {
          return rec.record_id === record_id;
        });
        var recordName = '';
        if (record.length) {
          recordName = record[0].userprofile_description;
        }
        return recordName;
      };
    },
    areasActive: function areasActive() {
      return this.select_profile_areas.filter(function (rec) {
        return rec.flag_active;
      });
    },
    profileUserActive: function profileUserActive() {
      return this.select_profile_users.filter(function (rec) {
        return rec.flag_active;
      });
    }
  },
  watch: {
    'record.area_id': function recordArea_id() {
      var area_id = this.record.area_id;
      if (this.select_profile_users) {
        this.profileFiltered = this.select_profile_users.filter(function (rec) {
          return rec.area_id === area_id;
        });
      }
    }
  },
  created: function created() {
    this.getRecords();
  },
  methods: {
    getRecords: function getRecords() {},
    getValuesToUpdate: function getValuesToUpdate(record, record_original) {
      var toSave = Object.keys(record).reduce(function (diff, key) {
        if (record[key] === record_original[key]) return diff;
        return _objectSpread(_objectSpread({}, diff), {}, _defineProperty({}, key, record[key]));
      }, {});
      var keys = Object.keys(toSave);
      var oldValues = {};
      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        if (key === 'load_date') continue;
        oldValues[key] = record_original[key];
      }
      toSave.record_id = record_original.record_id;
      return {
        toSave: toSave,
        oldValues: oldValues
      };
    },
    showModal: function showModal(data, mode) {
      if (data) {
        this.recordSelected = data.index;
        this.record = utils.cloneJSON(data.item);
        this.record_original = utils.cloneJSON(data.item);
      } else {
        this.record = {};
      }
      this.mode = mode;
      this.$root.$emit('bv::show::modal', this.modalId, '#btnShow');
    },
    toggleBusy: function toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    resetModal: function resetModal() {
      this.$bvModal.hide(this.modalId);
    },
    onDelete: function onDelete(record) {
      this.record = record;
      this.processing = false;
      this.busy = true;
    },
    onCancelDelete: function onCancelDelete() {
      this.busy = false;
    },
    onConfirmDelete: function onConfirmDelete() {
      var _this3 = this;
      this.processing = true;
      this.overlay_message = 'Deleting';
      var record_id = this.record.record_id;
      appApis.deleteRecord(this.modalId, record_id).then(function (response) {
        _this3.$store.dispatch("data-platform/" + _this3.dispatchName, _this3.modalId).then(function () {
          _this3.busy = _this3.processing = false;
        });
      });
    },
    rowClassFlag: function rowClassFlag(item) {
      return item && item.flag_active ? 'flag_active' : 'flag_deactive';
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};